import { useForm } from '../../../../packages/kiti/components/form/form/FormHandler'
import { usePlaceTypes } from '../../../../utils/helpers/placeTypes'

const COMMON_OPTION_PROPS = {
  rightIcon: 'RiNodeTree'
}

const useOptions = () => {
  const [placeTypes] = usePlaceTypes()

  return [
    // User
    {
      ...COMMON_OPTION_PROPS,
      id: '::{{user.id}}',
      name: 'Usuário salvo',
      entity: 'user',
      field: 'user'
    },
    {
      ...COMMON_OPTION_PROPS,
      id: '::{{service_order.user_id}}',
      name: 'Usuário da atividade salva',
      entity: 'service_order',
      field: 'user'
    },
    {
      ...COMMON_OPTION_PROPS,
      id: '::{{event.service_order.user_id}}',
      name: 'Usuário da atividade atualizada',
      entity: 'event',
      field: 'user'
    },
    {
      ...COMMON_OPTION_PROPS,
      id: '::{{non_compliance_event.service_order.user_id}}',
      name: 'Usuário da atividade da não conformidade',
      entity: 'non_compliance_event',
      field: 'user'
    },

    // Place
    ...placeTypes.map(type => ({
      ...COMMON_OPTION_PROPS,
      id: `::{{${type.key}.id}}`,
      name: `${type.name} salvo`,
      entity: type.key,
      field: 'place'
    })),

    {
      ...COMMON_OPTION_PROPS,
      id: '::{{service_order.place_id}}',
      name: 'Local da atividade salva',
      entity: 'service_order',
      field: 'place'
    },
    {
      ...COMMON_OPTION_PROPS,
      id: '::{{event.service_order.place_id}}',
      name: 'Local da atividade atualizada',
      entity: 'event',
      field: 'place'
    },
    {
      ...COMMON_OPTION_PROPS,
      id: '::{{non_compliance_event.service_order.place_id}}',
      name: 'Local da atividade da não conformidade',
      entity: 'non_compliance_event',
      field: 'place'
    },
    {
      ...COMMON_OPTION_PROPS,
      id: '::{{non_compliance_event.non_compliance.place_id}}',
      name: 'Local da atividade da não conformidade',
      entity: 'forms_non_compliance_event',
      field: 'place'
    },
    {
      ...COMMON_OPTION_PROPS,
      id: '::{{non_compliance.place_id}}',
      name: 'Local da atividade da não conformidade',
      entity: 'forms_non_compliance',
      field: 'place'
    },
    {
      ...COMMON_OPTION_PROPS,
      id: '::{{non_compliance.place_id}}',
      name: 'Local da não conformidade',
      entity: 'non_compliance',
      field: 'place'
    },
    {
      ...COMMON_OPTION_PROPS,
      id: '::{{forms_non_compliance_event.non_compliance.place_id}}',
      name: 'Local da atividade da não conformidade',
      entity: 'non_compliance_event',
      field: 'place'
    },

    // Checklist
    {
      ...COMMON_OPTION_PROPS,
      id: '::{{service_order.checklist_id}}',
      name: 'Questionário da atividade salva',
      entity: 'service_order',
      field: 'checklist'
    },
    {
      ...COMMON_OPTION_PROPS,
      id: '::{{event.service_order.checklist_id}}',
      name: 'Checklist da atividade atualizada',
      entity: 'event',
      field: 'checklist'
    },
    {
      ...COMMON_OPTION_PROPS,
      id: '::{{non_compliance_event.service_order.checklist_id}}',
      name: 'Checklist da atividade da não conformidade',
      entity: 'non_compliance_event',
      field: 'checklist'
    },
    {
      ...COMMON_OPTION_PROPS,
      id: '::{{non_compliance.question.checklist_id}}',
      name: 'Checklist da não conformidade',
      entity: 'non_compliance',
      field: 'checklist'
    },
    {
      ...COMMON_OPTION_PROPS,
      id: '::{{forms_non_compliance_event.reply.question.checklist_id}}',
      name: 'Questionário do formulário respondido',
      entity: 'forms_non_compliance_event',
      field: 'checklist'
    }
  ]
}

export const useComplementaryOptionsGenerator = () => {
  const form = useForm()
  const options = useOptions()
  return (field, innerForm) => {
    innerForm = innerForm || form

    if (innerForm.event?.startsWith('every_')) return false

    return options.filter(option => option.entity === innerForm.entity && (!field || option.field === field))
  }
}
